<template>
  <svg
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17L12.7507 12.7229M12.7507 12.7229C13.7747 11.6919 14.4074 10.2717 14.4074 8.7037C14.4074 5.55364 11.8538 3 8.7037 3C5.55364 3 3 5.55364 3 8.7037C3 11.8538 5.55364 14.4074 8.7037 14.4074C10.2858 14.4074 11.7174 13.7633 12.7507 12.7229Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
  </svg>
</template>
